// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bcl_a bhu_jx","ListItemIcon--empty":"bcl_b bhu_ff"};